$('document').ready(function () {
    if ($('#attention_bar_top').hasClass('att_bar_closed')) {
        $('body').removeClass('att_bar_opened').addClass('att_bar_closed');
        $('.attention_bar_top_expanded').hide();
        $('#for_expanded_mobile').removeClass('fa-chevron-up').addClass('fa-chevron-down');
        $('#attention_bar_top .att_bar_button').attr('aria-selected', 'false').children('.att_bar_chevron').removeClass('fa-chevron-up').addClass('fa-chevron-down');
        $('#attention_bar_top').slideUp();
        $('#att_bar_icon_menu_btn').prop('disabled', false);
    }
    //expand attention bar
    $('#attention_bar_top .att_bar_button').on('click', function () {
        let ariaSelected = $(this).attr('aria-selected');
        $('.attention_bar_top_expanded').slideUp('fast');
        $('#attention_bar_top .att_bar_button').attr('aria-selected', 'false').children('.att_bar_chevron').removeClass('fa-chevron-up').addClass('fa-chevron-down');
        if (ariaSelected == 'false') {
            $(this).attr('aria-selected', 'true').children('.att_bar_chevron').removeClass('fa-chevron-down').addClass('fa-chevron-up');
            $('#' + $(this).attr('aria-controls') + '').slideDown('slow');
        } else {
            $(this).attr('aria-selected', 'false').children('.att_bar_chevron').removeClass('fa-chevron-up').addClass('fa-chevron-down');
            $('#' + $(this).attr('aria-controls') + '').slideUp('fast');
        }
    });
    //expand attention bar mobile
    $('#for_expanded_mobile').on('click', function () {
        if ($(this).hasClass('fa-chevron-down')) {
            $('.attention_bar_top_expanded').slideDown('fast');
        } else {
            $('.attention_bar_top_expanded').slideUp('fast');
        }
        $(this).toggleClass('fa-chevron-down fa-chevron-up');
    });
    //close attention bar
    $('#att_bar_close_btn').on('click', function () {
        $('body').removeClass('att_bar_opened').addClass('att_bar_closed');
        $('.attention_bar_top_expanded').hide();
        $('#attention_bar_top .att_bar_button').attr('aria-selected', 'false').children('.att_bar_chevron').removeClass('fa-chevron-up').addClass('fa-chevron-down');
        $('#for_expanded_mobile').removeClass('fa-chevron-up').addClass('fa-chevron-down');
        $('#attention_bar_top').slideUp();
        $('#att_bar_icon_menu_btn').prop('disabled', false);
        document.cookie = "att_bar=closed;path=/";
    });
    //show attention bar
    $('#att_bar_icon_menu_btn').on('click', function () {
        $('body').removeClass('att_bar_closed').addClass('att_bar_opened');
        $(this).prop('disabled', true);
        $('#attention_bar_top').slideDown();
        document.cookie = "att_bar=opened;path=/";
    });
    //Get current menu items
    $('.menu_item_link, .sub_menu_item_link').each(function () {
        if ($(this).attr('href') == window.location.pathname || $(this).attr('href') == '/' + window.location.pathname.split('/')[1] + '/') {
            $(this).parent('li').addClass('current_menu_item');
        }
    });
    //Solid Stiky Header
    //Detect scroll direction
    let lastScrollTop = 0;
    let headerPosition = $('header').css('top');
    $(window).scroll(function (event) {
        let headerHeight = $('header').outerHeight();
        let fromTop = $(this).scrollTop();
        if (fromTop > lastScrollTop) { // downscroll
            if (fromTop > headerHeight) {
                $('header').css('top', -headerHeight);
                if ($('body').hasClass('home') && $('header').hasClass('header__old')) {
                    $('header').addClass('solid_header');
                }
            }
        } else if (fromTop < lastScrollTop) { // upscroll
            if (fromTop < headerHeight) {
                $('header').css({ 'top': headerPosition, 'position': 'absolute' });
                if ($('body').hasClass('home') && $('header').hasClass('header__old')) {
                    $('header').removeClass('solid_header');
                }
            } else {
                $('header').css({ 'top': headerPosition, 'position': 'fixed' });
            }
        }
        lastScrollTop = fromTop;
    });
    //mobile menu
    $('#mobile_menu_toggle_button').on('click', function () {
        $('body').toggleClass('opened_mobile_menu');
        $(this).toggleClass('opened_main_menu');
        $('.mega_menu_container').removeClass('show_mega_menu_mobile hide_mega_menu_mobile');
        $('#mobile_search_container').slideUp();
        $('.header__old #header_menu_col').slideToggle();
    });
    $('#main_menu .main_menu_item .fa-chevron-right').on('click', function () {
        $(this).parent('li').children('.mega_menu_container').addClass('show_mega_menu_mobile');
    });
    $('.mega_menu_container .fa-chevron-left').on('click', function () {
        $(this).closest('.mega_menu_container').addClass('hide_mega_menu_mobile').removeClass('show_mega_menu_mobile');
    });
    $('#header_mobile_search_icon').on('click', function () {
        $('#header_menu_col').slideUp();
        $('#mobile_search_container').slideToggle();
        $('body').removeClass('opened_mobile_menu');
        $('#mobile_menu_toggle_button').removeClass('opened_main_menu');
        $('.mega_menu_container').removeClass('show_mega_menu_mobile hide_mega_menu_mobile');
    });
    // Original width and height before resize
    var originalHeight = $(window).height();
    var originalWidth = $(window).width();
    function isKeyboard(height, width) {
        if (originalHeight > height && originalWidth === width) {
            return true;
        } else {
            return false;
        }
    }
    //ON RESIZE CLEAR
    $(window).resize(function () {
        let resizedHeight = $(window).height();
        let resizedWidth = $(window).width();
        if (!(isKeyboard(resizedHeight, resizedWidth))) {
            $('.attention_bar_top_expanded').slideUp('fast');
            $('#for_expanded_mobile').removeClass('fa-chevron-up').addClass('fa-chevron-down');
            $('#attention_bar_top .att_bar_button').attr('aria-selected', 'false').children('.att_bar_chevron').removeClass('fa-chevron-up').addClass('fa-chevron-down');
            $('#mobile_search_container').slideUp();
        }
        if ($(window).width() > 1189) {
            $('body').removeClass('opened_mobile_menu');
            $('#mobile_menu_toggle_button').removeClass('opened_main_menu');
            $('.mega_menu_container').removeClass('show_mega_menu_mobile hide_mega_menu_mobile');
            $('#header_menu_col').css('display', 'block');
        }
        if (!$('body').hasClass('opened_mobile_menu') && $(window).width() <= 1366) {
            $('#header_menu_col').css('display', 'none');
        }
    });
    //Search fields validation
    $('#header_search_field, #mobile_header_search_field').submit(function (e) {
        if ($(this).children('input').val() == '' || !$(this).children('input').val().replace(/\s/g, '').length) {
            e.preventDefault();
        }
    });
    //Language switcher show & hide
    $('#lang_switch_header_holder').hover(function () {
        $('#langs_list').stop();
        $('#langs_list').slideToggle();
    });

    $('#header__search-btn').click(function() {
        $('.header__search-form').toggleClass('active');
    });
    $('#close__search-form').click(function() {
        $('.header__search-form').toggleClass('active');
    });
    $('.mobile__main-menu .expand__menu').click(function() {
        $(this).closest('.main_menu_item').find('.mega_menu_container').addClass('expanded');
    });

    $('.mobile__main-menu .back__to-mainlink').click(function() {
        $('.mobile__main-menu .mega_menu_container').removeClass('expanded')
    });

    $('.header__new #mobile_menu_toggle_button').click(function() {
        $('.mobile__main-menu').toggleClass('menu__expanded');
    });
});